import React from 'react';
const StartupToolsCard = ({ title, image, description }) => {
    return (React.createElement("div", { className: "p-6 w-full bg-blue-50 rounded-2xl flex flex-col gap-4 justify-between" },
        React.createElement("div", { className: "w-full flex md:items-start justify-between md:flex-row flex-col-reverse md:gap-2 gap-4" },
            React.createElement("h5", { className: "text-gray-800 text-2xl leading-8 font-semibold" }, title),
            React.createElement("img", { src: image, className: "w-24 h-24 shrink-0 ml-auto", alt: title })),
        React.createElement("p", { className: "text-gray-700 text-lg leading-7 font-normal" }, description)));
};
export default StartupToolsCard;
